import clsx from "clsx";

import defaultStyles from "./ImportantInfoList.module.scss";
import { TextFieldComponentProps } from "@b2bportal/core-ui";
import { CoreUiComponents } from "@overrides/types";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";

export interface IImportantInfoListProps {
  className?: string;
  infoItems: string[];
  // infoProps?: TypographyProps;
  ordered?: boolean;
  title: string;
  titleProps?: TextFieldComponentProps;
}

export const ImportantInfoList = (
  props: IImportantInfoListProps
): JSX.Element => {
  const { className = "", infoItems, ordered = false, title } = props;
  const ListElement = ordered ? "ol" : "ul";

  const COMPONENT_KEY = CoreUiComponents.ImportantInfoList;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      <h4 className={cn("info-items-title")}>{title}</h4>
      <ListElement className={cn("info-list")}>
        {infoItems.map((infoText) => (
          <li className={cn("info-item")} key={infoText} type={"1"}>
            <div
              component="span"
              dangerouslySetInnerHTML={{ __html: infoText }}
              key={infoText}
              className={clsx("info-text")}
            />
          </li>
        ))}
      </ListElement>
    </div>
  );
};
